import * as React from 'react';

var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgLearnMoreFilled = function SvgLearnMoreFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#learn-more-filled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m13.23 11.76-3.729 3.729 1.266 1.296 5.026-5.025-5.026-5.025L9.501 8.03l3.729 3.729Zm-1.248 11.52c-1.593 0-3.09-.302-4.493-.907a11.637 11.637 0 0 1-3.658-2.462 11.631 11.631 0 0 1-2.464-3.657 11.212 11.212 0 0 1-.907-4.492c0-1.593.302-3.09.907-4.493A11.637 11.637 0 0 1 3.83 3.611a11.63 11.63 0 0 1 3.657-2.464A11.211 11.211 0 0 1 11.978.24c1.593 0 3.09.302 4.493.907a11.636 11.636 0 0 1 3.658 2.462 11.63 11.63 0 0 1 2.463 3.657 11.21 11.21 0 0 1 .908 4.492c0 1.593-.302 3.09-.907 4.493a11.635 11.635 0 0 1-2.462 3.658 11.63 11.63 0 0 1-3.657 2.463 11.211 11.211 0 0 1-4.492.908Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "learn-more-filled_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};

export { SvgLearnMoreFilled as default };
//# sourceMappingURL=learn-more-filled.svg.js.map
